module.exports = __webpack_public_path__ + "img/appStore.32598d1f.jpeg";